import { render, staticRenderFns } from "./Hotel.vue?vue&type=template&id=2544e5c3"
import script from "./Hotel.vue?vue&type=script&lang=js"
export * from "./Hotel.vue?vue&type=script&lang=js"
import style0 from "./Hotel.vue?vue&type=style&index=0&id=2544e5c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports